import { FormUploadInstallment } from "./Components/UploadFile/FormUploadInstallment";
import { AnaliseInstallments } from "./Components/AnaliseInstallments/AnaliseInstallments";
import { HeaderInstallment } from "./Components/HeaderInstallment";
import { ComingSoonOverlay } from "./Components/ComingSoonOverlay";
import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useContextParcelas } from "src/Contexts/Parcelas/ParcelasContext";
import { valuesDefaultUploadImportInstallments } from "src/Contexts/Parcelas/valuesDefaultInputsParcelas/ValueDefaultInputParcelas";

// Defina como true para mostrar o overlay de "Em breve" (modo preview para clientes)
const SHOW_COMING_SOON = true;

export default function PageImportInstallments() {
  const { setFilesUploadImportInstallments } = useContextParcelas();

  const [step, setStep] = useState<number>(1);

  useEffect(() => {
    if (step === 1) {
      setFilesUploadImportInstallments(valuesDefaultUploadImportInstallments);
    }
  }, [step]);

  return (
    <Box sx={{ padding: "16px" }}>
      <HeaderInstallment step={step} setStep={setStep} />

      <Box sx={{ position: "relative", minHeight: "500px" }}>
        {SHOW_COMING_SOON && <ComingSoonOverlay />}

        {step === 1 && <FormUploadInstallment step={step} setStep={setStep} />}
        {step === 2 && <AnaliseInstallments step={step} setStep={setStep} />}
      </Box>
    </Box>
  )
}